import { IContractSearchQuery } from '@dealpoint/types'

import defaultContractSearchQuery from './defaultContractSearchQuery'

export default function createContractSearchQuery(
  searchQuery?: Partial<IContractSearchQuery>
): IContractSearchQuery {
  return {
    ...defaultContractSearchQuery,
    ...searchQuery,
  }
}
